import { openTariffPayment } from '@crm/features/user-profile-menu';
import { getCrmTariffPaymentUrl } from '@crm/shared/config';
import { ProfilePage as MainProfilePage } from '@pages/Profile';

export const ProfilePage = () => {
    const handlePaySubscriptionClick = ({ removeProlong = false }: { removeProlong: boolean }) => {
        if (!removeProlong) {
            openTariffPayment(getCrmTariffPaymentUrl());
            return;
        }
        const urlWithoutProlong = getCrmTariffPaymentUrl().replace('?changeManual=1&prolong=1', '');
        openTariffPayment(urlWithoutProlong);
    };

    return (
        <div className="smetter-css w-full">
            <MainProfilePage onPaySubscriptionClick={handlePaySubscriptionClick} />
        </div>
    );
};
